import {
  getCurrencyMinorUnits,
  hasValidCurrencyPrecision,
  normalizeCurrencyCode,
} from "../currency/currencyPrecision";

export function fixedScaleAmountToCents(value) {
  const numeric = Number(String(value ?? "").replace(",", "."));
  if (!Number.isFinite(numeric)) return null;
  // Payment API compatibility: amount_cents always keeps the historical x100
  // storage scale, including currencies such as CLP and PYG.
  return Math.round(numeric * 100);
}

export function fixedScaleCentsToCurrencyAmount(cents, currencyCode, catalog = []) {
  const numeric = Number(cents);
  const currency = normalizeCurrencyCode(currencyCode) || "EUR";
  if (!Number.isFinite(numeric)) {
    return (0).toFixed(getCurrencyMinorUnits(currency, catalog));
  }
  return (numeric / 100).toFixed(getCurrencyMinorUnits(currency, catalog));
}

export function prepareCheckInManualPayment(value, currencyCode, catalog = []) {
  const currency = normalizeCurrencyCode(currencyCode) || "EUR";
  const amountCents = fixedScaleAmountToCents(value);
  if (!amountCents || amountCents <= 0) {
    return {
      valid: false,
      error: "Amount must be a positive number.",
    };
  }
  if (!hasValidCurrencyPrecision(value, currency, catalog)) {
    const minorUnits = getCurrencyMinorUnits(currency, catalog);
    return {
      valid: false,
      error: `${currency} accepts ${minorUnits} decimal places.`,
    };
  }
  return {
    valid: true,
    amount: fixedScaleCentsToCurrencyAmount(amountCents, currency, catalog),
    amount_cents: amountCents,
    currency,
  };
}
